import { CodeHighlight } from "./syntax-highlight/syntax-highlight";
export * from "./syntax-highlight/syntax-highlight";
export var CODE_HIGHLIGHT_DIRECTIVES = [
    CodeHighlight
];
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/code/index.js
// module id = 147
// module chunks = 4